import { z } from 'zod';
import { expectType } from './model.js';
import { EmptyPostBase, zFullPostBase, zPostBase } from './post.js';
export const zPollOption = z.object({
    value: z.string(),
    order: z.number(),
    key: z.string()
});
export const zPollFields = z.object({
    postType: z.literal('poll'),
    closeAfter: z.string().datetime().or(z.literal('')),
    closed: z.boolean(),
    options: z.array(zPollOption)
});
export const zPoll = zPostBase.merge(zPollFields);
expectType({});
expectType({});
export const zFullPoll = zFullPostBase.merge(zPollFields);
expectType({});
expectType({});
export const EmptyPoll = {
    ...EmptyPostBase,
    postType: 'poll',
    closeAfter: '',
    closed: false,
    options: []
};
export const EmptyPollOption = {
    value: '',
    order: 0,
    key: ''
};
